import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';
import { WarrantyPriceMatrixContainerModel } from '../../../../../../models/aggregates/erp/add-ons-extended-warranty/warranty-price-matrix-container.model';



@Injectable({
  providedIn: 'root'
})
export class WarrantyPriceMatrixService extends BaseApiTemplateService<WarrantyPriceMatrixContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
  Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'warranty-price-matrixes/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +Core2Config.ERP_PREFIX +Core2Config.FI_PREFIX + 'warranty-price-matrixes/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'warranty-price-matrixes/backoffice-ep';
    this.httpClient = http;
  }
}
